import { gql } from "@apollo/client";
import { VirtualAccountType } from "../types/VirtualAccountType";

export const FIELDS = `
    virtualAccountId
    clientId
    clientName
    type
    balance
    currency
    overdraftLimit
    activeTime
`;

export const GET_VIRTUAL_ACCOUNT_LISTING = gql`
    query VirtualAccountQuery($filters: VirtualAccountFilterTypeInput,
                       $pageRequest: PageRequestTypeInput) {
        getVirtualAccountPageable(filters: $filters, pageRequest: $pageRequest) {
            content{
                ${FIELDS}
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface VirtualAccountListResponse {
    getVirtualAccountPageable: VirtualAccountResponseType;
}

export interface VirtualAccountResponseType {
    content: VirtualAccountType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

interface PageRequestType {
    page: number;
    size: number;
    sortBy: string;
    sortDirection: string;
}
